import { useLayoutEffect } from 'react'

// The box a sticky element scrolls in: its nearest ancestor that clips its
// overflow (the FleetPage pane, .sw-pane), else the window's.
const scrollBox = el => {
  for (let node = el.parentElement; node && node !== document.body && node !== document.documentElement; node = node.parentElement) {
    if (/(auto|scroll|overlay|hidden)/.test(window.getComputedStyle(node).overflowY)) return node
  }
  return document.documentElement
}

// The height a sticky element has to sit in, as `--au-room` on it (px): the
// height of the box the page scrolls in, less that box's top padding (a
// sticky box sits under the padding). The Audit log's filter column caps
// its card with it (audit-log.scss), so a stuck column never runs past the
// bottom of what the reader can see, whatever sits above the pane (the
// header, an impersonation or deletion banner). Followed through the box's
// resizes; without ResizeObserver, or before the box is laid out, nothing
// is set and the stylesheet falls back to the window's height.
export const useScrollRoom = ref => {
  useLayoutEffect(() => {
    const el = ref.current
    if (!el || typeof window.ResizeObserver !== 'function') return undefined
    const box = scrollBox(el)
    const measure = () => {
      const height = box.clientHeight
      if (!height) return
      const padding = parseFloat(window.getComputedStyle(box).paddingTop) || 0
      el.style.setProperty('--au-room', `${Math.round(height - padding)}px`)
    }
    measure()
    const observer = new window.ResizeObserver(measure)
    observer.observe(box)
    return () => observer.disconnect()
  }, [ref])
}
